<div class="skeleton-entry">
  <div class="skeleton-header">
    <div class="skeleton-avatar stencil-shimmer"></div>
    <div class="skeleton-name stencil-shimmer"></div>
  </div>
  <div class="skeleton-contents">
    @for (message of [1, 2]; track message) {
      <div class="skeleton-content">
        <div class="skeleton-timestamp stencil-shimmer"></div>
        <div class="skeleton-texts">
          @for (line of [1, 2]; track line; let last = $last) {
            <div
              class="skeleton-text stencil-shimmer"
              [class.short]="last"
            ></div>
          }
        </div>
      </div>
    }
  </div>
</div>
